const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const validateTokenWithBackend = async (token, roomId) => {
  try {
    const response = await fetch(`${BACKEND_BASE_URL}/api/v1/join/validate-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, roomId })
    });
    
    if (!response.ok) {
      throw new Error('Token validation failed');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Token validation error:', error);
    throw error;
  }
};

export const getMeetingDetails = async (organizationId, meetingId) => {
  try {
    const response = await fetch(
      `${BACKEND_BASE_URL}/api/v1/organizations/${organizationId}/meetings/${meetingId}`
    );
    
    if (!response.ok) {
      throw new Error('Failed to get meeting details');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Get meeting details error:', error);
    throw error;
  }
};
